export const ProfileType = {
  patient: "patient",
  caregiver: "caregiver",
} as const;

export const ProfileStatus = {
  active: "active",
  inactive: "inactive",
  draft: "draft",
  pending_activation: "pending_activation",
} as const;

export const GENDER = {
  male: "male",
  female: "female",
  transgender: "transgender",
  non_binary: "non_binary",
  other: "other",
} as const;

export const genderOptions = Object.values(GENDER).map((value) => {
  return {
    value,
    label: value,
  } as const;
});

export const statusOptions = Object.values(ProfileStatus).map((value) => {
  return {
    value,
    label: value,
  } as const;
});

export const PROFILE_PAGE_SIZE_OPTIONS = [25, 50, 75, 100] as const;

export const DEFAULT_PROFILE_PAGE_SIZE = PROFILE_PAGE_SIZE_OPTIONS[0];
